import { filter } from 'lodash';
import axios from 'axios';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Typography,
  Backdrop,
  CircularProgress,
  Stack,
  Button
} from '@material-ui/core';

import moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import TextsmsIcon from '@material-ui/icons/Textsms';
import { baseUrl } from '../../../utils/constants';
import Scrollbar from '../../Scrollbar';
import SearchNotFound from '../../SearchNotFound';
import { useClaimsContext } from '../../../context/claims_context';
import { ClientListHead } from '../../_dashboard/clients';
import Controls from '../../controls/Controls';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'batchnu', label: 'File Name', alignRight: false },
  { id: 'serty2', label: 'Date Created', alignRight: true },
  { id: 'doccode3', label: '# of Records', alignRight: true },
  { id: 'docce3', label: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function DisbursementFile() {
  const {
    setBatchNo,
    clearBatch,
    setCurrentBatch,
    setClaimNo,
    clearClaims,
    getClaimById,
    getClaimDetailsById,
    populateClaimDocuments
  } = useClaimsContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });
  const navigate = useNavigate();
  const filename = `ClaimByDept_${moment().format('DD-MMM-YYYY')}.csv`;
  const classes = useStyles();

  useEffect(() => {
    getFilePendings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getFilePendings = async () => {
    setLoading(true);
    console.log('received batchNo');
    await axios(
      `${baseUrl}/api/accounting/getFilePendings?step=0&skip=10&orderBy=Date&order=false&filter=a`
    ).then(
      (res) => {
        setLoading(false);
        console.log('returned getFilePendings', res.data);
        console.log('returned getFilePendings', res.data.items);
        setDataList(res.data.items);
      },
      (error) => {
        setLoading(false);
        alert(`failed here ${{ error }}`);
      }
    );
  };

  const processDisbursements = async () => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    setLoading(true);
    await axios.post(`${baseUrl}/api/accounting/CreatePendingDisbursements`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Error in CreatePendingDisbursements!: ${result.replyMessage}`, 'error');
        } else {
          executePayouts();
        }
      },
      (error) => {
        setLoading(false);
        notifyPopup(`Error in CreatePendingDisbursements!: ${error}`, 'error');
      }
    );
  };

  const executePayouts = async () => {
    await axios.post(`${baseUrl}/api/accounting/ExecutePayouts`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Error in ExecutePayouts!: ${result.replyMessage}`, 'error');
        } else {
          notifyPopup(`Payouts Processed Successfully!`, 'success');
          navigate('/');
        }
      },
      (error) => {
        notifyPopup(`Error in ExecutePayouts!: ${error}`, 'error');
      }
    );
  };

  const handlefileDownload = (e) => {
    console.log('e filedoc', e);
    setLoading(true);
    fetch(`${baseUrl}/api/accounting/GetDisbursementFileStream?fileName=${e.row.fileName}`)
      .then((response) => response.blob())
      .then(
        (blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${e.row.fileName}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoading(false);
        },
        (error) => {
          notifyPopup(`Error in GetDisbursementFileStream!: ${error}`, 'error');
        }
      );
  };

  const sendSms = (e) => {
    axios
      .post(`${baseUrl}/api/claims/SendClaimsPaymentNotifications?fileName=${e.row.fileName}`)
      .then(
        (result) => {
          setLoading(false);
          if (result.replyStatus === 1) {
            notifyPopup(`Error in Saving Adjustment!: ${result.replyMessage}`, 'error');
          } else {
            notifyPopup('Adjustment Saved Successfully', 'success');
            navigate(-1);
          }
        },
        (error) => {
          notifyPopup(`Error in Saving Adjustment!: ${error}`, 'error');
        }
      );
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb="10">
        <Typography component="span" variant="h6" gutterBottom>
          Disbursement Files
        </Typography>
        {/* <Button
          type="button"
          variant="outlined"
          color="secondary"
          startIcon={<NoteAddIcon />}
          onClick={() => openNewSelf()}
        >
          Create Disbursements
        </Button> */}
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          startIcon={<NoteAddIcon />}
          onClick={() =>
            setConfirmDialog({
              isOpen: true,
              title: 'Are you sure you want to Disburse Pending Claims',
              subTitle: "You can't undo this action",
              heading: 'Process Disbursements',
              color: '#00000',
              onConfirm: () => {
                processDisbursements();
              }
            })
          }
        >
          Run Disbursements
        </Button>
        {/* <Button
          type="button"
          variant="outlined"
          color="secondary"
          startIcon={<TextsmsIcon />}
          onClick={() =>
            setConfirmDialog({
              isOpen: true,
              title: 'Are you sure you want to Send SMSs',
              subTitle: "You can't undo this action",
              heading: 'Send Disbursements SMSs',
              color: '#00000',
              onConfirm: () => {
                sendSms();
              }
            })
          }
        >
          Run Disbursements
        </Button> */}
      </Stack>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card>
        <TableContainer sx={{ minWidth: 800 }}>
          <Table size="small" aria-label="a dense table">
            <ClientListHead
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={dataList.length}
              numSelected={selected.length}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {filteredUsers
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  /* eslint-disable camelcase */
                  const { fileName, dateCreated, recordTotal } = row;
                  const isItemSelected = selected.indexOf(dateCreated) !== -1;

                  return (
                    <StyledTableRow
                      hover
                      key={dateCreated}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                    >
                      <TableCell padding="checkbox" />
                      <TableCell align="left">{fileName}</TableCell>
                      <TableCell align="right" component="th" scope="row" padding="none">
                        {moment(dateCreated).isValid()
                          ? moment(dateCreated).format('YYYY-MM-DD')
                          : ''}
                      </TableCell>
                      <TableCell align="right">{recordTotal}</TableCell>
                      <TableCell align="right">
                        <IconButton onClick={() => handlefileDownload({ row })}>
                          <VisibilityIcon sx={{ color: '#03a9f4' }} />
                        </IconButton>
                        <IconButton onClick={() => sendSms({ row })}>
                          <TextsmsIcon sx={{ color: '#03a9f4' }} />
                        </IconButton>
                      </TableCell>
                    </StyledTableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            {isUserNotFound && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={filterName} />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <Controls.Notification notify={notify} setNotify={setNotify} />
        <Controls.ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[4, 8, 12]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
